import React, { useEffect, useState, useRef } from 'react';
import Layout from '../../layout/default';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown, Breadcrumb, Modal, Row, Col, Form, Card, Button, Spinner } from 'react-bootstrap';
import { Block, Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem } from '../../components';
import AuthLogoff from '../../pages/auths/AuthLogoff';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL = 'api/Tenants/';

function Tenants() {
  const api = useApiClient();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingTenant, setEditingTenant] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [form, setForm] = useState({
    externalTenantId: '',
    name: '',
    hostname: '',
    displayName: '',
    email: '',
    companyAddress: '',
    companyPhoneNumber: '',
    subscriptionId: 1,
    paymentCustomerId: '',
    paymentMethodId: ''
  });
  const [bTenantChanged, setTenantChange] = useState(false);

  const dataFetchedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    fetchTenants();
    fetchSubscriptions();
  }, []);

  const fetchTenants = async () => {
    try {
      const response = await api.get(baseURL);
      setData(response.data);
    } catch (err) {
      setError(err);
    }
  };

  const fetchSubscriptions = async () => {
    try {
      const response = await api.get('api/tenants/subscriptions');
      setSubscriptions(response.data);
    } catch (err) {
      console.error('Failed to fetch subscriptions:', err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSave = async () => {
    try {
      if (editingTenant) {
        await api.put(`${baseURL}${editingTenant.tenantId}`, form);
      } else {
        await api.post(baseURL, form);
      }
      setShowModal(false);
      fetchTenants();
    } catch (err) {
      alert('Save failed: ' + err);
    }
  };

  const handleEdit = async (tenantId) => {
    try {
      const response = await api.get(`${baseURL}${tenantId}`);
      setForm({
        ...response.data,
        paymentCustomerId: response.data.paymentCustomerId || '',
        paymentMethodId: response.data.paymentMethodId || ''
      });
      setEditingTenant(response.data);
      setShowModal(true);
    } catch (err) {
      alert('Failed to fetch tenant details');
    }
  };

  const handleDelete = async (tenantId) => {
    if (!window.confirm('Are you sure you want to delete this tenant?')) return;
    try {
      await api.delete(`${baseURL}${tenantId}`);
      fetchTenants();
    } catch (err) {
      alert('Delete failed: ' + err);
    }
  };

  const handleSelectTenant = async (tenantId) => {
    const emailId = 'harindas@yahoo.com';
    if (!emailId) {
      alert('Admin email not found');
      return;
    }
    try {
      await api.post(`${baseURL}select`, { adminUserEmailId: emailId, tenantId });
      setTenantChange(true);
    } catch (err) {
      alert('Failed to select tenant: ' + err.message);
    }
  };

  const handleAddNew = () => {
    setForm({
      externalTenantId: '', name: '', hostname: '', displayName: '', email: '', companyAddress: '', companyPhoneNumber: '',
      subscriptionId: subscriptions.length > 0 ? subscriptions[0].subscriptionId : 1,
      paymentCustomerId: '', paymentMethodId: ''
    });
    setEditingTenant(null);
    setShowModal(true);
  };

  if (error) return <div>Error: {error.message}</div>;
  if (!data) return (
    <Layout title="Tenants" content="container">
      <Spinner animation="border" variant="primary" />
    </Layout>
  );
  if (bTenantChanged) return <AuthLogoff />;


// import Layout from '../../layout/default';
// import { useEffect, useState, useRef } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Dropdown, Breadcrumb, Modal, Row, Col, Form, Card, Button, Spinner } from 'react-bootstrap';
// import { Block, Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem } from '../../components';
// import ApiCall from '../ApiService/ApiCall';
// import AuthLogoff from '../../pages/auths/AuthLogoff';

// const baseURL = 'api/Tenants/';

// function Tenants() {
//   const [data, setData] = useState(null);
//   const [error, setError] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [editingTenant, setEditingTenant] = useState(null);
//   const [subscriptions, setSubscriptions] = useState([]);
//   const [form, setForm] = useState({
//     externalTenantId: '',
//     name: '',
//     hostname: '',
//     displayName: '',
//     email: '',
//     companyAddress: '',
//     companyPhoneNumber: '',
//     subscriptionId: 1,
//     paymentCustomerId: '',      // <-- new
//     paymentMethodId: ''         // <-- new
//   });

//   const [bTenantChanged, setTenantChange] = useState(false);

//   const dataFetchedRef = useRef(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (dataFetchedRef.current) return;
//     dataFetchedRef.current = true;
//     fetchTenants();
//     fetchSubscriptions();
//   }, []);

//   const fetchTenants = async () => {
//     try {
//       const response = await ApiCall.get(baseURL);
//       setData(response.data);
//     } catch (err) {
//       setError(err);
//     }
//   };

//   const fetchSubscriptions = async () => {
//     try {
//       const response = await ApiCall.get('api/tenants/subscriptions');
//       setSubscriptions(response.data);
//     } catch (err) {
//       console.error('Failed to fetch subscriptions:', err);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });
//   };

//   const handleSave = async () => {
//     try {
//       if (editingTenant) {
//         await ApiCall.put(`${baseURL}${editingTenant.tenantId}`, form);
//       } else {
//         await ApiCall.post(baseURL, form);
//       }
//       setShowModal(false);
//       fetchTenants();
//     } catch (err) {
//       alert('Save failed: ' + err);
//     }
//   };

//   const handleEdit = async (tenantId) => {
//     try {
//       const response = await ApiCall.get(`${baseURL}${tenantId}`);
//       setForm({
//         ...response.data,
//         paymentCustomerId: response.data.paymentCustomerId || '',
//         paymentMethodId: response.data.paymentMethodId || ''
//       });
//       setEditingTenant(response.data);
//       setShowModal(true);
//     } catch (err) {
//       alert('Failed to fetch tenant details');
//     }
//   };

//   const handleDelete = async (tenantId) => {
//     if (!window.confirm('Are you sure you want to delete this tenant?')) return;
//     try {
//       await ApiCall.delete(`${baseURL}${tenantId}`);
//       fetchTenants();
//     } catch (err) {
//       alert('Delete failed: ' + err);
//     }
//   };

//   const handleSelectTenant = async (tenantId) => {
//     const emailId = "harindas@yahoo.com"; //user.emailId;//  localStorage.getItem('adminEmail'); // or get from auth context
  
//     if (!emailId) {
//       alert("Admin email not found in localStorage.");
//       return;
//     }
  
//     try {
//       await ApiCall.post(`${baseURL}select`, {
//         adminUserEmailId: emailId,
//         tenantId: tenantId
//       });
  
//       setTenantChange(true);
//       //      fetchTenants();
//       //alert(`Tenant ${tenantId} selected successfully.`);

//     } catch (err) {
//       alert('Failed to select tenant: ' + err.message);
//     }
//   };
  

//   const handleAddNew = () => {
//     setForm({
//       externalTenantId: '',
//       name: '',
//       hostname: '',
//       displayName: '',
//       email: '',
//       companyAddress: '',
//       companyPhoneNumber: '',
//       subscriptionId: subscriptions.length > 0 ? subscriptions[0].subscriptionId : 1,
//       paymentCustomerId: '',      // <-- new
//       paymentMethodId: ''         // <-- new
//     });
//     setEditingTenant(null);
//     setShowModal(true);
//   };

//   if (error) return <div>Error: {error.message}</div>;
//   if (!data) {
//     return (
//       <Layout title="Tenants" content="container">
//         <Spinner animation="border" variant="primary" />
//       </Layout>
//     );
//   }

//   if(bTenantChanged){
//     return (<AuthLogoff/>)
//   }

  return (
    
    <Layout title="Tenants" content="container">
      <Breadcrumb className="breadcrumb-arrow">
        <Breadcrumb.Item><Link to={`/`}>Management</Link></Breadcrumb.Item>
        <Breadcrumb.Item active>Tenants</Breadcrumb.Item>
      </Breadcrumb>

      <Block.Head>
        <Block.HeadBetween className="align-items-start">
          <Block.HeadContent>
            <div className="d-flex flex-column flex-md-row align-items-md-center">
              <div className="mt-3 mt-md-0 ms-md-3">
                <h3 className="title mb-1">Tenant Management</h3>
                <span className="small">Manage tenants records in the system</span>
              </div>
            </div>
          </Block.HeadContent>
          <Block.HeadContent tools>
            <Button variant="primary" onClick={handleAddNew}>
              <Icon name="plus"></Icon><span>New Tenant</span>
            </Button>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Row className="g-gs">
          {data.map(({ tenants, subscription }) => (
            <Col sm="6" xl="4" xxl="3" key={tenants.tenantId}>
              <Card className="text-center h-100">
                <Card.Body>
                  <div className="mt-1 mb-4">
                    <div className="h5 mb-1">{tenants.name}</div>
                    <div className="small">ID: {tenants.tenantId}</div>
                  </div>
                  <div className="mb-3">
                    <div>{tenants.companyAddress}</div>
                    <div className="small">{tenants.email}</div>
                    <div className="small">{tenants.companyPhoneNumber}</div>
                  </div>
                  <Row className="g-gs justify-content-center">
                    <Col className="col-6">
                      <div className="h6 mb-1">{subscription.subscriptionName}</div>
                    </Col>
                    <Col className="col-6">
                      <div className="small">{subscription.pricePlanType}</div>
                      <div className="small">£{subscription.price}</div>
                    </Col>
                  </Row>
                  <Row>
                    <hr />             
                    <Col className="col-6">
                      <Button variant="light" size="md" onClick={() => handleDelete(tenants.tenantId)}>x Delete</Button>
                    </Col>
                    <Col className="col-6">
                      <Button variant="primary" size="md" onClick={() => handleEdit(tenants.tenantId)}>Edit Tenant</Button>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col>
                        <Button variant="success" size="sm" onClick={() => handleSelectTenant(tenants.tenantId)}>
                        Select
                        </Button>
                    </Col>
                  </Row>

                </Card.Body>
                <Dropdown className="position-absolute top-0 end-0 p-3">
                  <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
                    <Icon name="more-v"></Icon>
                  </Dropdown.Toggle>
                  <Dropdown.Menu as={CustomDropdownMenu} align="end">
                    <LinkList>
                      <LinkListItem onClick={() => handleEdit(tenants.tenantId)}>
                        <Icon name="edit"></Icon><span>Edit</span>
                      </LinkListItem>
                      <LinkListItem onClick={() => handleDelete(tenants.tenantId)}>
                        <Icon name="trash"></Icon><span>Delete</span>
                      </LinkListItem>
                    </LinkList>
                  </Dropdown.Menu>
                </Dropdown>
              </Card>
            </Col>
          ))}
        </Row>
      </Block>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editingTenant ? 'Edit Tenant' : 'Add New Tenant'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>            
            <Form.Group className="mb-2">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" name="name" value={form.name} onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" name="email" value={form.email} onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Company Address</Form.Label>
              <Form.Control type="text" name="companyAddress" value={form.companyAddress} onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Company Phone</Form.Label>
              <Form.Control type="text" name="companyPhoneNumber" value={form.companyPhoneNumber} onChange={handleInputChange} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>External Tenant ID</Form.Label>
              <Form.Control
                type="text"
                name="externalTenantId"
                value={form.externalTenantId}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Display Name</Form.Label>
              <Form.Control
                type="text"
                name="displayName"
                value={form.displayName}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Subscription</Form.Label>
              <Form.Select name="subscriptionId" value={form.subscriptionId} onChange={handleInputChange}>
                {subscriptions.map(sub => (
                  <option key={sub.subscriptionId} value={sub.subscriptionId}>
                    {sub.subscriptionName} - £{sub.price} ({sub.pricePlanType})
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            {/* New fields for paymentCustomerId and paymentMethodId */}
            <Form.Group className="mb-2">
              <Form.Label>Payment Customer ID</Form.Label>
              <Form.Control
                type="text"
                name="paymentCustomerId"
                value={form.paymentCustomerId}
                onChange={handleInputChange}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>Payment Method ID</Form.Label>
              <Form.Control
                type="text"
                name="paymentMethodId"
                value={form.paymentMethodId}
                onChange={handleInputChange}
              />
            </Form.Group>
          </Form>         
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={handleSave}>Save</Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}

export default Tenants;
